import './../../styles/Account.css';

import Container from '../../components/Layout/Container';

import Input, { onEnter } from '../../components/TextField/Input';
import { Button } from '../../components/Button/Button';

import { useState } from 'react';
import { handleVerificationCode, handlePhone, isBlankStr, validateEmail, validatePhone } from '../../hooks/useValidate';
import { fetchPost } from '../../hooks/fetch';
import { openAlert } from '../../components/Modal/MsgBox';

export default function FindPassword() {
	const pageName = '비밀번호 찾기';
	const [userInfo, setUserInfo] = useState({ loginId: "", name: "", phone: "", company: "", verificationCode: "" });
	const [sendVerifyCode, setSendVerifyCode] = useState(false);

	const onChangeUserInfo = (e) => {
		const { name, value } = e.target;
		let save;
		if(name === "verificationCode") { save = handleVerificationCode(value); }
		else if (name === "phone") { save = handlePhone(value); }
		else { save = value; }

		if (name !== "verificationCode") setSendVerifyCode(false);

		setUserInfo({
			...userInfo,
			[name]: save,
			...(name !== "verificationCode" ? { verificationCode: "" } : {})
		});
	}

	const onKeyDown = (e) => {
		onEnter(e, submit);
	}

	const validateInput = () => {
		if(!validateEmail(userInfo.loginId, "loginId")) {
			return false;
		}
		if(isBlankStr(userInfo.name)) {
			openAlert("이름을 입력해 주세요.");
			return false;
		}
		if (!validatePhone(userInfo.phone)) return false;
		if (isBlankStr(userInfo.company)) {
			openAlert("소속을 입력해주세요.");
			return false;
		}
		return true;
	}

	function sendEmailVerifyCode() {
		if(!validateInput()) return;

		setSendVerifyCode(false);
		fetch("/api-tlo/emailVerification/send/findpw", {
			method: "POST",
			headers: { "Content-Type": "application/json; charset=UTF-8" },
			body: JSON.stringify({
				loginId: userInfo.loginId,
				email: userInfo.loginId,
				name: userInfo.name,
				phone: userInfo.phone.replace(/-/g, ""),
				company: userInfo.company,
			}),
		}).then(async (res) => {
			if (res.status === 200 || res.status === 201) {
				setSendVerifyCode(true);
				openAlert("인증번호를 전송 했습니다.");
				return;
			}
			if (res.status === 400) {
				const json = await res.json();
				throw new Error(json.message || "인증번호를 전송 할 수 없습니다.");
			}
			throw new Error("인증번호를 전송 할 수 없습니다.");
		}).catch((error) => openAlert(error.message));
	}

	function submit() {
		if(!validateInput()) return;
		if(!sendVerifyCode) {
			openAlert("인증번호 요청이 필요합니다.");
			return false;
		}
		if(isBlankStr(userInfo.verificationCode)) {
			openAlert("인증번호를 입력해 주세요.");
			return false;
		}

		fetchPost(
			"/emailVerification/check/findpw",
			"인증",
			{ ...userInfo, email: userInfo.loginId, phone: userInfo.phone.replace(/-/g, "") },
			() => { window.location.href = `/account/reset/password` }
		);
	}

	return (
		<main id="account-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<Container>
				<div className="page-content login-page">
					<div className="gs-account-form">
						<h1 className="top">{pageName}</h1>
						<p className="gs-bullet fc-cerulean-blue">
							회원가입 시 입력하신 정보를 입력하셔야 합니다.
						</p>
						<div>
							<Input.Group>
								<Input
									id="user-id"
									type="email"
									label="아이디(이메일)를 입력해주세요."
									placeholder="아이디(이메일) 입력"
									name="loginId"
									value={userInfo.loginId}
									onChange={onChangeUserInfo}
									onKeyDown={onKeyDown}
									maxLength={100}
								/>
								<Input
									id="user-name"
									type="text"
									label="이름을 입력해주세요."
									placeholder="이름 입력"
									name="name"
									value={userInfo.name}
									onChange={onChangeUserInfo}
									onKeyDown={onKeyDown}
									maxLength={20}
								/>
								<Input
									id="phone"
									type="tel"
									label="휴대폰 번호를 입력해주세요."
									placeholder="휴대폰 번호 입력"
									name="phone"
									value={userInfo.phone}
									onChange={onChangeUserInfo}
									onKeyDown={onKeyDown}
									maxLength={13}
								/>
								<Input
									id="company"
									type="text"
									label="소속을 입력해주세요."
									placeholder="소속 입력"
									name="company"
									value={userInfo.company}
									onChange={onChangeUserInfo}
									onKeyDown={onKeyDown}
									maxLength={30}
								/>
								<div className="gs-input-box flex">
									<Input
										id="authentication-num"
										type="tel"
										label="인증번호를 입력해주세요."
										placeholder="인증번호 입력"
										name="verificationCode"
										value={userInfo.verificationCode}
										onChange={onChangeUserInfo}
										maxLength={6}
										onKeyDown={onKeyDown}
									/>
									<Button
										type="button"
										className="full silver"
										onClick={sendEmailVerifyCode}
									>
										인증번호 요청
									</Button>
								</div>
							</Input.Group>
							<div className="gs-bottom-btns col">
								<Button
									className="submit"
									onClick={submit}
								>
									<strong>확 인</strong>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
